import { Dispatch } from "redux";
import { setLoading } from "./global";
import CollectPointService from "service/CollectPoint";
import { showMessage } from "utilities/helper";
import { CollectPointPayloadTypes } from "utilities/types/CollectPoint";

export const getAllCollectPoints =
  (
    page: number = 1,
    search: string = "",
    limit: number = 10,
    filterTenant = 1
  ) =>
  async (dispatch: Dispatch) => {
    dispatch(setLoading(true));
    dispatch({
      type: "SET_COLLECT_POINT_CURRENT_PAGE",
      currentPage: page,
    });
    dispatch({
      type: "SET_SEARCH_COLLECT_POINT",
      searchValue: search,
    });

    try {
      const data = await CollectPointService.getAllCollectPoints(
        page,
        search,
        limit,
        filterTenant
      );

      dispatch(setLoading(false));
      dispatch({ type: "SET_COLLECT_POINT", value: data.point_codes });
      dispatch({
        type: "SET_COLLECT_POINT_PAGE",
        totalPage: !!data.point_codes.length ? data.last_page : 1,
        limitPage: limit,
        lengthPage: !!data.point_codes.length ? data.total_data : 1,
      });
      dispatch({
        type: "SET_COLLECT_POINT_FILTER_PAGE",
        filterTenantPage: filterTenant,
      });
    } catch (err: any) {
      dispatch(setLoading(false));
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };

export const storeCollectPoint =
  (form: CollectPointPayloadTypes, handleCloseModal: () => void) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await CollectPointService.storeCollectPoint(payload);
      const { currentPage, searchValue, limitPage, filterTenantPage } =
        getState().collectPointReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(
        getAllCollectPoints(
          currentPage,
          searchValue,
          limitPage,
          filterTenantPage
        ) as any
      );

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const updateCollectPoint =
  (
    collectPointId: string,
    form: CollectPointPayloadTypes,
    handleCloseModal: () => void
  ) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await CollectPointService.updateCollectPoint(
        collectPointId,
        payload
      );
      const { currentPage, searchValue, limitPage, filterTenantPage } =
        getState().collectPointReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(
        getAllCollectPoints(
          currentPage,
          searchValue,
          limitPage,
          filterTenantPage
        ) as any
      );

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const deleteCollectPoint =
  (collectPointId: string, handleCloseModal: () => void) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    try {
      const data = await CollectPointService.deleteCollectPoint(collectPointId);
      const { currentPage, searchValue, limitPage, filterTenantPage } =
        getState().collectPointReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_CONFIRMATION", value: false });

      dispatch(
        getAllCollectPoints(
          currentPage,
          searchValue,
          limitPage,
          filterTenantPage
        ) as any
      );

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error:", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const importCollectPoint =
  (importFile: File) => async (dispatch: Dispatch) => {
    dispatch({ type: "SET_IMPORT_LOADING", value: true });
    try {
      const data = await CollectPointService.importCollectPoint(importFile);

      dispatch({ type: "SET_IMPORT_LOADING", value: false });

      dispatch(getAllCollectPoints() as any);

      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_IMPORT_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };
